import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle-btn"
      onClick={toggleTheme}
      title={theme === 'light' ? t('common.activate_dark_mode', 'Ativar modo escuro') : t('common.activate_light_mode', 'Ativar modo claro')}
      aria-label={theme === 'light' ? t('common.activate_dark_mode', 'Ativar modo escuro') : t('common.activate_light_mode', 'Ativar modo claro')}
    >
      <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
    </button>
  );
};

export default ThemeToggle;
